/**
 * YNS Study Space: "My study calendar" on Home (#ynsCalendar).
 * A month view where students build their own plan: pick a day, add what they will study (typed, or a quick pick),
 * tick items off. Today and the exam date are marked. Saved in this browser (localStorage).
 * localStorage: yns_cal_plan { "YYYY-MM-DD": [{ id, t, done }] }, reads yns_exam_date (set in the welcome / countdown).
 */
(function () {
  'use strict';

  var KEY = 'yns_cal_plan', root, view, sel;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var QUICK = ['Watch 1 lecture', 'Read 20 pages', 'Do 50 Q-Bank questions', 'Review my Miss Log', 'Rest day'];

  function read(k, f) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : f; } catch (e) { return f; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function parse(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function plan() { return read(KEY, {}); }
  function exam() { var e = read('yns_exam_date', null); return typeof e === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(e) ? e : null; }

  function render() {
    if (!root) return;
    var p = plan(), today = iso(new Date()), ex = exam();
    var y = view.getFullYear(), m = view.getMonth(), first = new Date(y, m, 1), lead = (first.getDay() + 6) % 7, days = new Date(y, m + 1, 0).getDate();
    var cells = '';
    for (var i = 0; i < lead; i++) cells += '<span class="ycal-d ycal-d--pad" aria-hidden="true"></span>';
    for (var d = 1; d <= days; d++) {
      var k = iso(new Date(y, m, d)), items = p[k] || [], left = items.filter(function (x) { return !x.done; }).length;
      var cls = 'ycal-d' + (k === today ? ' is-today' : '') + (k === sel ? ' is-sel' : '') + (k === ex ? ' is-exam' : '') + (k < today ? ' is-past' : '') + (items.length && !left ? ' is-clear' : '');
      cells += '<button type="button" class="' + cls + '" data-ycal-day="' + k + '" aria-pressed="' + (k === sel) + '" aria-label="' + MONTHS[m] + ' ' + d + (k === ex ? ', exam day' : '') + (items.length ? ', ' + items.length + ' planned' : '') + '">' +
        '<span class="ycal-d__n">' + d + '</span>' + (k === ex ? '<span class="ycal-d__flag" aria-hidden="true">&#127937;</span>' : '') +
        (items.length ? '<span class="ycal-d__dots" aria-hidden="true">' + items.slice(0, 3).map(function (x) { return '<i class="' + (x.done ? 'is-done' : '') + '"></i>'; }).join('') + '</span>' : '') + '</button>';
    }
    var list = p[sel] || [], sd = parse(sel);
    var dayTitle = sel === today ? 'Today' : sd.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
    var daysToExam = ex ? Math.round((parse(ex) - parse(sel)) / 864e5) : null;
    root.innerHTML =
      '<div class="ycal-head"><div><h3 class="ycal-title">My study calendar</h3><p class="ycal-sub">Plan your own days. Pick a day, add what you will study, tick it off.</p></div></div>' +
      '<div class="ycal-body"><div class="ycal-left"><div class="ycal-nav"><button type="button" data-ycal="prev" aria-label="Previous month">&lsaquo;</button><b>' + MONTHS[m] + ' ' + y + '</b><button type="button" data-ycal="next" aria-label="Next month">&rsaquo;</button><button type="button" class="ycal-today" data-ycal="today">Today</button></div>' +
        '<div class="ycal-grid" role="group" aria-label="' + MONTHS[m] + ' ' + y + '">' + DOW.map(function (w) { return '<span class="ycal-dow">' + w + '</span>'; }).join('') + cells + '</div></div>' +
        '<div class="ycal-day">' +
          '<p class="ycal-day__k">' + (daysToExam !== null && daysToExam > 0 ? daysToExam + ' days before your exam' : daysToExam === 0 ? '&#127937; Exam day' : 'Your plan') + '</p>' +
          '<h4 class="ycal-day__t">' + esc(dayTitle) + '</h4>' +
          (list.length ? '<ul class="ycal-items">' + list.map(function (x) {
            return '<li class="' + (x.done ? 'is-done' : '') + '"><label><input type="checkbox" data-ycal-tick="' + x.id + '"' + (x.done ? ' checked' : '') + '><span>' + esc(x.t) + '</span></label><button type="button" class="ycal-x" data-ycal-del="' + x.id + '" aria-label="Remove ' + esc(x.t) + '">&times;</button></li>';
          }).join('') + '</ul>' : '<p class="ycal-empty">Nothing planned yet.</p>') +
          '<form class="ycal-add" data-ycal-form><input type="text" maxlength="80" placeholder="Add to this day, e.g. Gold Book chapter 4" aria-label="Add to this day"><button type="submit">Add</button></form>' +
          '<div class="ycal-quick">' + QUICK.map(function (q) { return '<button type="button" data-ycal-quick="' + esc(q) + '">+ ' + esc(q) + '</button>'; }).join('') + '</div>' +
        '</div>' +
      '</div>';
  }

  function add(text) {
    text = String(text || '').trim(); if (!text) return;
    var p = plan(); (p[sel] = p[sel] || []).push({ id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5), t: text.slice(0, 80), done: false });
    write(KEY, p); render();
    var i = root.querySelector('.ycal-add input'); if (i) i.focus();
  }

  function onClick(e) {
    var b = e.target.closest('[data-ycal], [data-ycal-day], [data-ycal-quick], [data-ycal-del]'); if (!b) return;
    if (b.dataset.ycalDay) { sel = b.dataset.ycalDay; var d = parse(sel); if (d.getMonth() !== view.getMonth()) view = new Date(d.getFullYear(), d.getMonth(), 1); render(); return; }
    if (b.dataset.ycalQuick) { add(b.dataset.ycalQuick); return; }
    if (b.dataset.ycalDel) { var p = plan(); p[sel] = (p[sel] || []).filter(function (x) { return x.id !== b.dataset.ycalDel; }); if (!p[sel].length) delete p[sel]; write(KEY, p); render(); return; }
    var a = b.dataset.ycal;
    if (a === 'prev') view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
    if (a === 'next') view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
    if (a === 'today') { var t = new Date(); view = new Date(t.getFullYear(), t.getMonth(), 1); sel = iso(t); }
    render();
  }
  function onChange(e) {
    var id = e.target.dataset && e.target.dataset.ycalTick; if (!id) return;
    var p = plan(); (p[sel] || []).forEach(function (x) { if (x.id === id) x.done = e.target.checked; });
    write(KEY, p);
    if (e.target.checked) { try { window.YNSStreakSystem && window.YNSStreakSystem.recordActivity('calendar_task', { task: id }); } catch (err) {} }
    render();
  }
  function onSubmit(e) {
    if (!e.target.matches('[data-ycal-form]')) return;
    e.preventDefault(); add(e.target.querySelector('input').value);
  }

  function init() {
    root = document.getElementById('ynsCalendar'); if (!root) return;
    var t = new Date(); view = new Date(t.getFullYear(), t.getMonth(), 1); sel = iso(t);
    root.addEventListener('click', onClick); root.addEventListener('change', onChange); root.addEventListener('submit', onSubmit);
    // the countdown / welcome can change the exam date: redraw so the flag moves
    window.addEventListener('yns:plan', render); window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === 'yns_exam_date') render(); });
    render();
  }
  window.YNSCalendar = { render: function () { render(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
